"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USAGE_DISPLAY_NAMES = void 0;
const generation_types_1 = require("./generations/generation-types");
/**
 * Legacy usage identifiers that exist in the DB but are not part of the GenerationType enum.
 * These come from the old ad-format and asset creation flows.
 */
var LegacyUsageIdentifier;
(function (LegacyUsageIdentifier) {
    LegacyUsageIdentifier["AD_FORMAT_TALKING_CHARACTER"] = "AD_FORMAT_TALKING_CHARACTER";
    LegacyUsageIdentifier["AD_FORMAT_UGC_WITH_CONTENT"] = "AD_FORMAT_UGC_WITH_CONTENT";
    LegacyUsageIdentifier["AD_FORMAT_SLIDESHOW"] = "AD_FORMAT_SLIDESHOW";
    LegacyUsageIdentifier["AD_FORMAT_FAST_CUT"] = "AD_FORMAT_FAST_CUT";
    LegacyUsageIdentifier["AD_FORMAT_WALL_OF_TEXT"] = "AD_FORMAT_WALL_OF_TEXT";
    LegacyUsageIdentifier["AD_FORMAT_MULTI_SCENE_VIDEO"] = "AD_FORMAT_MULTI_SCENE_VIDEO";
    LegacyUsageIdentifier["AD_FORMAT_STATIC"] = "AD_FORMAT_STATIC";
    LegacyUsageIdentifier["AD_FORMAT_SORA_2"] = "AD_FORMAT_SORA_2";
    LegacyUsageIdentifier["AD_FORMAT_AGENT_AD"] = "AD_FORMAT_AGENT_AD";
    LegacyUsageIdentifier["ASSET_TEXT_TO_IMAGE"] = "ASSET_TEXT_TO_IMAGE";
    LegacyUsageIdentifier["ASSET_TEXT_TO_VIDEO"] = "ASSET_TEXT_TO_VIDEO";
    LegacyUsageIdentifier["ASSET_LIP_SYNC"] = "ASSET_LIP_SYNC";
    LegacyUsageIdentifier["ASSET_ACTOR_SCENE"] = "ASSET_ACTOR_SCENE";
    LegacyUsageIdentifier["ASSET_VEO_3"] = "ASSET_VEO_3";
    LegacyUsageIdentifier["ASSET_SORA_2"] = "ASSET_SORA_2";
    LegacyUsageIdentifier["ASSET_IMAGE_TO_VIDEO"] = "ASSET_IMAGE_TO_VIDEO";
    LegacyUsageIdentifier["ASSET_AUDIO"] = "ASSET_AUDIO";
    LegacyUsageIdentifier["ASSET_VIDEO"] = "ASSET_VIDEO";
    LegacyUsageIdentifier["ASSET_IMAGE"] = "ASSET_IMAGE";
    LegacyUsageIdentifier["ASSET_TEXT"] = "ASSET_TEXT";
    LegacyUsageIdentifier["ASSET_GENERATED_MUSIC"] = "ASSET_GENERATED_MUSIC";
    LegacyUsageIdentifier["ASSET_BACKGROUND_AUDIO"] = "ASSET_BACKGROUND_AUDIO";
    LegacyUsageIdentifier["STATIC_SLIDESHOW"] = "STATIC_SLIDESHOW";
    LegacyUsageIdentifier["STATIC_ASPECT_RATIO_RESIZE"] = "STATIC_ASPECT_RATIO_RESIZE";
})(LegacyUsageIdentifier || (LegacyUsageIdentifier = {}));
/**
 * Unified display name map for all usage identifiers.
 */
exports.USAGE_DISPLAY_NAMES = {
    // Legacy ad format identifiers
    [LegacyUsageIdentifier.AD_FORMAT_TALKING_CHARACTER]: 'Talking Character Ad',
    [LegacyUsageIdentifier.AD_FORMAT_UGC_WITH_CONTENT]: 'UGC Ad',
    [LegacyUsageIdentifier.AD_FORMAT_SLIDESHOW]: 'Slideshow Ad',
    [LegacyUsageIdentifier.AD_FORMAT_FAST_CUT]: 'Fast Cut Ad',
    [LegacyUsageIdentifier.AD_FORMAT_WALL_OF_TEXT]: 'Wall of Text Ad',
    [LegacyUsageIdentifier.AD_FORMAT_MULTI_SCENE_VIDEO]: 'Multi-Scene Video Ad',
    [LegacyUsageIdentifier.AD_FORMAT_STATIC]: 'Static Ad',
    [LegacyUsageIdentifier.AD_FORMAT_SORA_2]: 'Sora 2 Ad',
    [LegacyUsageIdentifier.AD_FORMAT_AGENT_AD]: 'Agent Ad',
    // Asset identifiers
    [LegacyUsageIdentifier.ASSET_TEXT_TO_IMAGE]: 'Text to Image',
    [LegacyUsageIdentifier.ASSET_TEXT_TO_VIDEO]: 'Text to Video',
    [LegacyUsageIdentifier.ASSET_LIP_SYNC]: 'Lip Sync',
    [LegacyUsageIdentifier.ASSET_ACTOR_SCENE]: 'Actor Scene',
    [LegacyUsageIdentifier.ASSET_VEO_3]: 'Veo 3 Video',
    [LegacyUsageIdentifier.ASSET_SORA_2]: 'Sora 2 Video',
    [LegacyUsageIdentifier.ASSET_IMAGE_TO_VIDEO]: 'Image to Video',
    [LegacyUsageIdentifier.ASSET_AUDIO]: 'Audio',
    [LegacyUsageIdentifier.ASSET_VIDEO]: 'Video',
    [LegacyUsageIdentifier.ASSET_IMAGE]: 'Image',
    [LegacyUsageIdentifier.ASSET_TEXT]: 'Text',
    [LegacyUsageIdentifier.ASSET_GENERATED_MUSIC]: 'Generated Music',
    [LegacyUsageIdentifier.ASSET_BACKGROUND_AUDIO]: 'Background Audio',
    // Legacy statics (not in GenerationType but exist in DB)
    [LegacyUsageIdentifier.STATIC_SLIDESHOW]: 'Slideshow',
    [LegacyUsageIdentifier.STATIC_ASPECT_RATIO_RESIZE]: 'Aspect Ratio Resize',
    // Agent-owned static generation
    [generation_types_1.GenerationType.SKILL_BASED_STATIC]: 'Agent Static Ad',
    // Generation templates - Video ads
    [generation_types_1.GenerationType.SORA]: 'Sora Video',
    [generation_types_1.GenerationType.SEEDANCE_2]: 'Seedance 2 Video',
    [generation_types_1.GenerationType.SORA_REMIX]: 'Sora Remix',
    [generation_types_1.GenerationType.SORA_HOOK_DEMO_CTA]: 'Sora Hook Demo CTA',
    [generation_types_1.GenerationType.WALL_OF_TEXT]: 'Wall of Text',
    [generation_types_1.GenerationType.FAST_CUTS]: 'Fast Cuts',
    [generation_types_1.GenerationType.POV_HOOK_VIDEO]: 'POV Hook Video',
    [generation_types_1.GenerationType.HOOK_VIDEO_SPEAKING_MOBILE_APP]: 'Hook Video Speaking',
    [generation_types_1.GenerationType.HOOK_VIDEO_SPEAKING_MOBILE_APP_VEO]: 'Hook Video Speaking (Veo)',
    [generation_types_1.GenerationType.SHORT_CINEMATIC_SOCIAL_AD_ECOM]: 'Short Cinematic Social Ad',
    [generation_types_1.GenerationType.VIDEO_ACTOR_IN_SCENE]: 'Video Actor in Scene',
    [generation_types_1.GenerationType.VIDEO_LAPTOP_INSPIRATIONAL]: 'Video Laptop Inspirational',
    [generation_types_1.GenerationType.VIDEO_WEBSITE_LAPTOP_PERSON]: 'Video Website Laptop Person',
    [generation_types_1.GenerationType.VIDEO_ACTOR_HOLDS_LAPTOP]: 'Video Actor Holds Laptop',
    [generation_types_1.GenerationType.VIDEO_BRANDED_STREET_INTERVIEW]: 'Branded Street Interview',
    [generation_types_1.GenerationType.FAST_APP_STREET_INTERVIEW]: 'Fast App Street Interview',
    [generation_types_1.GenerationType.RAGING_TEACHER]: 'Raging Teacher',
    [generation_types_1.GenerationType.PODCAST_SNIPPET]: 'Podcast Snippet',
    [generation_types_1.GenerationType.PODCAST_LONG]: 'Podcast Long',
    [generation_types_1.GenerationType.ANIMATE_STATIC]: 'Animate Static',
    // Generation templates - Actor
    [generation_types_1.GenerationType.ACTOR_SPEAKING]: 'Actor Speaking',
    [generation_types_1.GenerationType.ACTOR_SPEAKING_TALKING_HEAD]: 'Actor Talking Head',
    [generation_types_1.GenerationType.ACTOR_EMOTIONS]: 'Actor Emotions',
    [generation_types_1.GenerationType.ACTOR_HOOK_DEMO]: 'Actor Hook Demo',
    [generation_types_1.GenerationType.CHARACTER_MOTION_CONTROL]: 'Character Motion Control',
    // Generation templates - Product / E-Commerce
    [generation_types_1.GenerationType.PRODUCT_IN_INSPIRATIONAL_SCENE]: 'Product in Inspirational Scene',
    [generation_types_1.GenerationType.PRODUCT_IN_USE]: 'Product in Use',
    [generation_types_1.GenerationType.PRODUCT_IS_PLACED]: 'Product Placed',
    [generation_types_1.GenerationType.PRODUCT_ANIMATED_SHOT]: 'Product Animated Shot',
    [generation_types_1.GenerationType.ACTOR_HOLDS_PRODUCT_INTO_THE_CAMERA]: 'Actor Holds Product',
    [generation_types_1.GenerationType.ACTOR_HOLDS_PRODUCT_IN_HAND]: 'Actor Holds Product in Hand',
    [generation_types_1.GenerationType.ACTOR_HOLDS_PRODUCT_IN_HAND_SELFIE]: 'Actor Holds Product Selfie',
    [generation_types_1.GenerationType.ACTOR_SHOWS_APP_ON_PHONE]: 'Actor Shows App on Phone',
    [generation_types_1.GenerationType.APP_IN_HAND]: 'App in Hand',
    // Generation templates - Composite / Experiment
    [generation_types_1.GenerationType.COMPOSITE_LAPTOP_AD]: 'Composite Laptop Ad',
    [generation_types_1.GenerationType.FULL_ECOM_AD_EXPERIMENT]: 'Full E-Commerce Ad',
    [generation_types_1.GenerationType.FULL_WEBSITE_AD_EXPERIMENT]: 'Full Website Ad',
    // Agent
    [generation_types_1.GenerationType.VIDEO_AGENT]: 'Agent Video',
    [generation_types_1.GenerationType.SEEDANCE_VIDEO_AGENT]: 'Agent Seedance Video',
};
